import React from 'react';
import PropTypes from 'prop-types';
import { CHILDREN_PROP_TYPES } from 'propTypes';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import ButtonGroup from '@mui/material/ButtonGroup';

import { styled } from '@mui/system';

import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

const StyledButtonGroup = styled(ButtonGroup)({
  display: 'revert',
  position: 'relative'
});

const StyledPaper = styled(Paper, {
  shouldForwardProp: muiPropForwarding('setMaxHeightValue')
})(({ theme, setMaxHeightValue }) => ({
  paddingBottom: 0,
  marginTop: 8,
  maxHeight: setMaxHeightValue ? 150 : 'none',
  overflow: 'auto',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.mediumTofu}`,
  borderRadius: 4,
  backgroundColor: getPageBackgroundColor(theme)
}));

const ScrollBox = ({ selectedIdx, children }) => {
  const refs = React.useRef(
    React.Children.map(children, () => React.createRef())
  );
  React.useEffect(() => {
    if (refs.current[selectedIdx] && refs.current[selectedIdx].current) {
      refs.current[selectedIdx].current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
  const count = React.Children.count(children);
  const setMaxHeightValue = count > 3;
  return (
    <StyledButtonGroup data-testId="scroll-box">
      <Box>
        <StyledPaper setMaxHeightValue={setMaxHeightValue}>
          <List>
            {children.map((child, idx) => (
              <List key={idx} ref={refs.current[idx]}>
                {child}
              </List>
            ))}
          </List>
        </StyledPaper>
      </Box>
    </StyledButtonGroup>
  );
};

ScrollBox.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  selectedIdx: PropTypes.number.isRequired
};

export default ScrollBox;
